import { useCallback } from 'react';
import { isSafari } from '@/utils/platformUtils';
import { RecognitionState } from '@/types/speechRecognition';

export const useRecognitionCleanup = (state: RecognitionState) => {
  const { recognitionRef, setIsListening } = state;

  const forceCleanup = useCallback(async () => {
    console.log('Forcing cleanup of speech recognition...');
    
    if (recognitionRef.current) {
      try {
        recognitionRef.current.stop();
        // Give a small delay before nulling the reference
        setTimeout(() => {
          recognitionRef.current = null;
          setIsListening(false);
        }, 100);
      } catch (error) {
        console.error('Error during recognition cleanup:', error);
      }
    }
    
    if (isSafari() && window.streamReference) {
      try {
        const tracks = window.streamReference.getTracks();
        console.log('Cleaning up audio tracks:', tracks.length);
        tracks.forEach(track => {
          track.stop();
        });
        window.streamReference = undefined;
      } catch (error) {
        console.error('Error cleaning up Safari audio stream:', error);
      }
    }
  }, [recognitionRef, setIsListening]);

  return { forceCleanup };
};